import { memo } from "react";
import { Modal, Box } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { IconLargeUpload } from "../../../icons/Icon";
import styles from './upload.module.scss';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 476,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '6px',
  outline: 'none',
};

interface UploadModalProps {
  open: boolean;
  handleClose: () => void;
  title?: string;
  discription?: string;
  handleFileUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const UploadModal: React.FC<UploadModalProps> = ({
  open,
  handleClose,
  title = "Default Title",
  discription = "Default Description",
  handleFileUpload
}) => {

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      className="modal"
    >
      <Box sx={modalStyle}>
        <div className="modal-header flex justify-content-between align-items-center">
          {title && <h3 className="modal-title">{title}</h3>}
          <button className="close" onClick={handleClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-body">
          <div className={styles.disc}>{discription}</div>
          <label
            className={`${styles.uploadBtn} flex justify-content-center align-items-center`}
            htmlFor="myFile"
          >
            <input
              type="file"
              id="myFile"
              name="filename"
              className="d-none"
              accept=".xlsx,.xls,.csv"
              onChange={handleFileUpload} // Handle file upload
            />
            <strong><IconLargeUpload /></strong>
            <span className={styles.uploadText}>
              Click to Upload
            </span>
          </label>
        </div>
      </Box>
    </Modal>
  );
};

export default memo(UploadModal);
